import { render } from "./Preview.vue?vue&type=template&id=5f10b973"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=5f10b973&scope=true&lang=scss"
script.render = render

export default script